export default __webpack_public_path__ + "media/images/icons_fc/folders-73df5061aee892178ed433d4245d3a05.png";